import { elements } from '#components/generics/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const handlers = new WeakMap()
const fieldsets = new WeakMap()
const radios = new WeakMap()

const onInput = object(listener, {
  type: input,
  passive,
  task: (wrapper, { target }) => {
    handlers.get(target)?.(target, fieldsets.get(target))

    if (target.matches('[type="radio"]')) {
      const previous = radios.get(wrapper)

      if (previous) {
        handlers.get(previous)?.(previous, fieldsets.get(previous))
      }

      radios.set(wrapper, target)
    }
  }
})

export const handle = (toggler, handler) => {
  const togglerParent = closest(`.${elements.field}, .${elements.new_field}`, toggler)
  const fieldset = togglerParent.nextElementSibling

  fieldsets.set(toggler, fieldset)
  handlers.set(toggler, handler)

  queueMicrotask(async () => {
    await removed(fieldset)
    fieldsets.delete(toggler)
  })
}

export default wrapper => {
  const radioChecked = one(`[type="radio"]:checked`, wrapper)
  
  if (radioChecked) {
    radios.set(wrapper, radioChecked)
  }
  onInput.listen(wrapper)

  queueMicrotask(async () => {
    await removed(wrapper)
    radios.delete(wrapper)
  })
}
